import React from 'react'
import './SymbolButton.css'

interface SymbolButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: string
  className?: string
  disabled?: boolean
}

export const SymbolButton = ({ onClick, icon, className = '', disabled = false }: SymbolButtonProps) =>
  <button
    disabled={disabled}
    onClick={onClick}
    className={`sb-default sb-${icon} ${className}`}
  />
